var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStargaze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9rnkjsek8a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "url(#hhxyemx5ub)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.975 6.504c.305-.469 1.033-.274 1.062.285l.318 6.058c.013.25.185.463.427.528l5.86 1.57c.54.145.58.897.057 1.098l-5.663 2.174a.578.578 0 0 0-.37.57l.317 6.057c.03.56-.674.829-1.026.394l-3.818-4.714a.578.578 0 0 0-.656-.176L8.82 22.522c-.523.2-.997-.385-.692-.854l3.304-5.088a.578.578 0 0 0-.035-.678l-3.818-4.715c-.352-.435.058-1.066.599-.921l5.86 1.57a.578.578 0 0 0 .633-.244l3.304-5.088z",
    fill: "url(#sqgq3ivijc)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.859 27.72c6.472 1.734 13.126-2.107 14.86-8.58s-2.107-13.126-8.58-14.86C12.667 2.546 6.013 6.387 4.28 12.86c-1.734 6.472 2.107 13.125 8.58 14.86zm-.225.837c6.935 1.858 14.064-2.258 15.922-9.192C30.414 12.428 26.3 5.3 19.364 3.442 12.429 1.585 5.3 5.7 3.442 12.635 1.584 19.57 5.699 26.7 12.634 28.557z",
    fill: "url(#158gf1si9d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.75 16c0 8.698-7.052 15.75-15.75 15.75S.25 24.698.25 16 7.302.25 16 .25 31.75 7.302 31.75 16z",
    stroke: "#fff",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hhxyemx5ub",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sqgq3ivijc",
    x1: 10.455,
    y1: 8.936,
    x2: 19.882,
    y2: 26.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD7176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#D9AE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#AFE38F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#65C7D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187DD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "158gf1si9d",
    x1: 9.105,
    y1: 4.059,
    x2: 23.678,
    y2: 28.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A63C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#775AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#DFC136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#AADFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#3596DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#003390"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9rnkjsek8a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStargaze);
export default __webpack_public_path__ + "static/media/stargaze.f96c125a37529de43a7a9eaefe874acc.svg";
export { ForwardRef as ReactComponent };